import { Container, Fade } from "@mui/material";
import { Route, Routes, useNavigate } from "react-router";
import DashboardPage from "./DashboardPage";
import AppBar from "../components/AppBar";
const DashboardPageRoutes = () => {
    const navigate = useNavigate();

    return (
        <Routes>
            <Route index element={<DashboardPage />} />
        </Routes>
    )
}

export default function DashboardRoutes() {
    return (
        <>
            <AppBar />
            <Fade appear in timeout={500}>
                <Container maxWidth="xl">
                    <DashboardPageRoutes />
                </Container>
            </Fade>
        </>
    )
}

